<template>
    <v-list-item class="px-0">
        <v-list-item-content style="width: 120px">{{ title }}:</v-list-item-content>
        <v-list-item-content class="align-end d-inline-block">
            <v-avatar color="#ccc" class="mr-1" size="25">
                <img v-if="user.photoURL" :src="user.photoURL"
                    :alt="user.displayName"
                >
                <span v-else>
                    {{user.displayName.slice(0, 2)}}
                </span>
            </v-avatar>
            {{ user.displayName }}
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
  name: 'user-info-label',
  props: {
    title: {
      type: String,
      default() {
        return 'User';
      },
    },
    user: {
      type: Object,
      default() {
        return {
          displayName: 'None',
        };
      },
    },
  },
};
</script>
